const createCustomMarker = ({ OverlayView = google.maps.OverlayView, ...args }) => {
  class CustomMarker extends OverlayView {
    constructor() {
      super();
      this.latlng = args.latlng;
      this.html = args.html;
      this.map = args.map;
      this.infoPopup = args.infoPopup;
      this.info = args.info;
      this.setMap(args.map);
      this.div = null;
    }

    createDiv() {
      this.div = document.createElement('div');
      this.div.style.position = 'absolute';

      if (this.html) {
        this.div.innerHTML = this.html;
      }

      google.maps.event.addDomListener(this.div, 'click', (event) => {
        google.maps.event.trigger(this, 'click');
      });
    }

    appendDivToOverlay() {
      this.getPanes().overlayMouseTarget.appendChild(this.div);

      if (this.infoPopup && this.info) {
        google.maps.event.addDomListener(this.div, 'mouseover', () => {
          this.infoPopup.setContent(this.info);
          this.infoPopup.open(this.map, this);
        });
      }
    }

    positionDiv() {
      const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
      if (point) {
        this.div.style.left = `${point.x - this.div.offsetWidth / 2}px`;
        this.div.style.top = `${point.y - this.div.offsetHeight / 2}px`;
      }
    }

    draw() {
      if (!this.div) {
        this.createDiv();
        this.appendDivToOverlay();
      }
      this.positionDiv();
    }

    remove() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
    }

    getPosition() {
      return this.latlng;
    }

    getDraggable() {
      return false;
    }
  }

  return new CustomMarker();
};

export default createCustomMarker;
